export default __webpack_public_path__ + "avatar-placeholder.1cc46fb2.svg";